export const matchesReceived = 'matchesReceived';
export const matchDeleted = 'matchDeleted';

export default {
  matchesReceived,
  matchDeleted,
}


// WEBPACK FOOTER //
// ./modules/actions/match.actions.js